export * from './checkAuth'
export * from './findMenuInfoByPath'

export const isGroupMenu = (menu) => menu?.children && !menu?.path

export const getSelectedMenuInfo = (selectedKey, menus = []) => {
  let subMenu
  let menu
  let parentMenus = []

  if (selectedKey) {
    traverseTree(menus, (node, pnode, pnodes) => {
      if (!isGroupMenu(node) && node.code === selectedKey) {
        subMenu = node
        menu = pnode
        parentMenus = pnodes
        return false
      }
    })
  } else {
    // 默认找到第一个菜单项
    traverseTree(menus, (node, pnode, pnodes) => {
      if (!isGroupMenu(node)) {
        subMenu = node
        menu = pnode
        parentMenus = pnodes
        return false
      }
    })
  }

  return {
    subMenu,
    menu,
    parentMenus,
  }
}

export const hasLevel3 = (menus) => {
  return menus?.some((menu) => menu?.children?.some((item) => item?.children?.length))
}

export const isNewTabMenu = (menu) => {
  const { target, path } = menu || {}

  return target === '_blank' || (/^http/i.test(path) && /blankType=newTarget/.test(path))
}

export const openInNewTab = (path) => {
  window.open(path, '_blank')
}

export const traverseTree = (treeData, callback, pnode, pnodes = []) => {
  ;(treeData || []).every((node, index) => {
    let result

    if (callback) {
      result = callback(
        node,
        pnode,
        pnodes?.length ? pnodes : [pnode].filter((item) => !!item),
        index
      )
    }

    // 回调函数返回false则终止遍历
    if (result !== false) {
      node && traverseTree(node.children || [], callback, node, [node, ...pnodes])
    }

    return result !== false
  })

  return treeData
}

export const safeParseJSON = (str, defaultObj) => {
  let result

  try {
    result = JSON.parse(str)
  } catch (err) {
    console.warn('json parse error:', err)
    result = typeof defaultObj === 'undefined' ? str : defaultObj
  }

  return result || defaultObj
}
